module.exports = __webpack_public_path__ + "img/subscription.d5977c55.svg";